import CryptoJS from "crypto-js";

const rememberLoginKey = "RememberLogin@123";

export function encryptInfo(value, password) {
    const valueEncrypt = CryptoJS.AES.encrypt(value, rememberLoginKey).toString();
    const passwordEncrypt = CryptoJS.AES.encrypt(
        password,
        rememberLoginKey
    ).toString();
    localStorage.setItem(
        "remember_login",
        JSON.stringify({
            value: valueEncrypt,
            password: passwordEncrypt,
        })
    );
}

export function decryptInfo(value, password) {
    const valueBytes = CryptoJS.AES.decrypt(value, rememberLoginKey);
    const passwordBytes = CryptoJS.AES.decrypt(password, rememberLoginKey);
    return {
        value: valueBytes.toString(CryptoJS.enc.Utf8),
        password: passwordBytes.toString(CryptoJS.enc.Utf8),
    };
}